import { useState } from "react";
import axios from "axios";
import "./VentasUploader.css";
import Swal from 'sweetalert2';

const VentasPasadas = () => {
  const [file, setFile] = useState(null);
  const [sucursal, setSucursal] = useState("");
  const [periodoInicio, setPeriodoInicio] = useState("");
  const [periodoFin, setPeriodoFin] = useState("");
  const [categoria, setCategoria] = useState("");
  const [loading, setLoading] = useState(false);

  const enviarXML = async () => {
    if (!file || !sucursal || !periodoInicio || !periodoFin || !categoria) {
      Swal.fire({
        title: 'Campos incompletos',
        text: 'Por favor, completa todos los campos y selecciona un archivo antes de continuar.',
        icon: 'warning',
        confirmButtonText: 'Aceptar',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("sucursal", sucursal);
    formData.append("periodo_inicio", periodoInicio);
    formData.append("periodo_fin", periodoFin);
    formData.append("almacen", categoria);

    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_API_URL}/xml2/ventasAnterior`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      Swal.fire({
        title: 'XML cargado correctamente',
        text: 'El archivo de la semana anterior se ha procesado exitosamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar'
      });
      setFile(null);
      setSucursal("");
      setPeriodoInicio("");
      setPeriodoFin("");
      setCategoria("");
    } catch (error) {
      console.error("Error al cargar el XML:", error);
      Swal.fire({
        title: 'Error al cargar el archivo',
        text: 'Hubo un problema al procesar el archivo XML. Por favor, verifica el formato y vuelve a intentarlo.',
        icon: 'error',
        confirmButtonText: 'Aceptar',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ventas-uploader">
      <h2>Subir Ventas de la Semana Anterior</h2>
      <label>
        Archivo XML:
        <input type="file" accept=".xml" onChange={(e) => setFile(e.target.files[0])} />
      </label>
      <label>
        Sucursal:
        <input type="text" placeholder="Sucursal" value={sucursal} onChange={(e) => setSucursal(e.target.value)} />
      </label>
      <label>
        Fecha Inicio:
        <input type="date" value={periodoInicio} onChange={(e) => setPeriodoInicio(e.target.value)} />
      </label>
      <label>
        Fecha Fin:
        <input type="date" value={periodoFin} onChange={(e) => setPeriodoFin(e.target.value)} />
      </label>
      <label>
        Almacen:
        <input type="text" placeholder="Almacen" value={categoria} onChange={(e) => setCategoria(e.target.value)} />
      </label>
      <div className="alerta-almacen">
        Ingresa el almacen como: GC1, GC2, GP1, GP2 u OFERTAS
      </div>
      <button onClick={enviarXML} disabled={loading}>
        {loading ? "Subiendo..." : "Subir Archivo Semana Anterior"}
      </button>
    </div>
  );
};

export default VentasPasadas;